import * as Sentry from '@sentry/react';

export function captureException(str) {
  Sentry.captureException(new Error(str));
}

export function captureExceptionWithContext(str, obj) {
  Sentry.captureException(new Error(str), {
    contexts: obj,
  });
}

export function setTag(tag_key, tag_val) {
  Sentry.setTag(tag_key, tag_val);
}

export function setContext(context_str, context_obj) {
  Sentry.setContext(context_str, context_obj);
}
